import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class AlertMessageComponent {
  @Input() type: 'info' | 'error' = 'info';
  @Input() bordered: boolean = true;

  get wrapperClasses(): string[] {
    if (this.type === 'error') {
      return ['text-gray-800', 'border-l-4', 'border-red-500'];
    }

    if (this.type === 'info' && this.bordered) {
      return ['text-gray-800', 'border-l-4', 'border-blue-500'];
    }

    return ['text-gray-800'];
  }

  get iconWrapperClasses(): string[] {
    if (this.type === 'error') {
      return ['text-red-600', 'pt-1'];
    }
    if (this.type === 'info' && this.bordered) {
      return ['text-blue-500', 'pt-1'];
    }
    return ['text-gray-500', 'pt-1'];
  }

  get iconClass(): string {
    return this.type === 'error'
      ? 'pi pi-exclamation-circle'
      : 'pi pi-info-circle';
  }
}
